module.exports = __webpack_public_path__ + "static/media/fontawesome-webfont.c1e38fd9.svg";